import React, { useContext } from "react";
// React Bootstrap
import { Accordion, Card, Button, Alert } from "react-bootstrap";
// Componentes
import FormJuridicos from "../formularios/FormJuridicos";
import VistaJuridicos from "../vistas/VistaJuridicos";
import Cargos from "../../../cargos/Cargos";
// Contexto
import { ModalContext } from "../../../../context/modalContext";

const Juridicos = ({ datosMisionObra, handlePutMisionObra, idProvincia, idMision }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  return (
    <React.Fragment>
      <Accordion defaultActiveKey="0">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              Datos jurídicos
            </Accordion.Toggle>
            <Button
              variant="outline-primary"
              size="sm"
              className="float-right mr-4"
              onClick={() => {
                modalSetShow(true, "80%");
                modalSetTitle("Editar datos jurídicos");
                modalSetContent(<FormJuridicos defaultValues={datosMisionObra} submissionHandler={handlePutMisionObra} />);
              }}
            >
              Editar
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className={"bg-light"}>
              <VistaJuridicos datosMisionObra={datosMisionObra} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              Representantes legales
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className={"bg-light"}>
              <Cargos type="rlObra" idEntidad={idProvincia} idSubEntidad={idMision} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </React.Fragment>
  );
};

export default Juridicos;
